import { memoize } from "lodash";
import {
  E_STORAGE_TYPE,
  STORAGE_DEFAULTS,
  TStorageKey
} from "../../../constants/storage-constants";
import { observable } from "mobx";
import { isNullOrUndefined, reduce } from "et3-type-guards";

class CoreStorageStore {
  storageType = observable.box<E_STORAGE_TYPE>(E_STORAGE_TYPE.LOCAL);

  getStorage = () => {
    try {
      if (typeof window === "undefined") {
        return null;
      }
      const storage =
        this.storageType.get() === E_STORAGE_TYPE.SESSION
          ? window.sessionStorage
          : window.localStorage;
      if (isNullOrUndefined(storage)) {
        return null;
      }
      return storage;
    } catch {
      return null;
    }
  };

  get = <T>(key: TStorageKey): T =>
    reduce(
      () => JSON.parse(this.getStorage().getItem(key)),
      STORAGE_DEFAULTS[key]
    );

  set = <T>(key: TStorageKey, value: T): void => {
    try {
      this.getStorage().setItem(key, JSON.stringify(value));
    } catch {}
  };

  remove = (key: TStorageKey): void => {
    try {
      this.getStorage().removeItem(key);
    } catch {}
  };

  clear = (): void => {
    try {
      this.getStorage().clear();
    } catch {}
  };
}

const getCoreStorageStore = memoize((storageType: E_STORAGE_TYPE) => {
  const store = new CoreStorageStore();
  store.storageType.set(storageType);
  return store;
});
export default getCoreStorageStore;
